


































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { AccountNavigation, App } from '@/models'
import ApiClient from '@/services/api-client'
import { ACCOUNT_PROFILE_ADMIN } from '@/utils/constants'

@Component
export default class AccountNavigationComponent extends Vue {
  @Prop({ required: true }) accountId!: string
  @Prop({ required: true }) apps!: App[]

  private ACCOUNT_PROFILE_ADMIN = ACCOUNT_PROFILE_ADMIN
  private navigationItems: AccountNavigation[] = []
  private totalNavigationItems = 0
  private selectedAppFilter: string | null = null
  private loading = false
  private navigationCurrentPage = 1
  private navigationPerPage = 10

  get appFilterOptions() {
    return [
      { value: null, text: this.$t('account_detail.navigation.all_apps').toString() },
      ...this.apps.map(app => ({
        value: app.appId,
        text: app.name
      }))
    ]
  }

  get navigationFields() {
    return [
      {
        key: 'url',
        label: this.$t('account_detail.navigation.url').toString(),
        sortable: false
      },
      {
        key: 'appId',
        label: this.$t('account_detail.navigation.app').toString(),
        sortable: false
      },
      {
        key: 'createdOn',
        label: this.$t('account_detail.navigation.visited_at').toString(),
        sortable: false
      }
    ]
  }

  get navigationPaginated() {
    return this.navigationItems
  }

  @Watch('navigationCurrentPage')
  async onPageChange() {
    await this.loadNavigation()
  }

  async mounted() {
    await this.loadNavigation()
  }

  async loadNavigation() {
    try {
      this.loading = true
      const offset = (this.navigationCurrentPage - 1) * this.navigationPerPage
      const result = await ApiClient.getAccountNavigation(
        this.accountId,
        this.selectedAppFilter || undefined,
        this.navigationPerPage,
        offset
      )
      this.navigationItems = result.items
      this.totalNavigationItems = result.totalResults
    } catch (error) {
      console.error('Error loading navigation:', error)
      this.$bvToast.toast(this.$t('account_detail.navigation.error_loading').toString(), {
        title: this.$t('account_detail.error_title').toString(),
        variant: 'danger',
        solid: true
      })
    } finally {
      this.loading = false
    }
  }

  async onAppFilterChange() {
    this.navigationCurrentPage = 1
    await this.loadNavigation()
  }

  getAppName(appId: string): string {
    const app = this.apps.find(a => a.appId === appId)
    return app ? app.name : appId
  }
}
